import { YammerState } from '../../state/types';
import { getExperimentTreatment } from '../experiments/selectors';
import { isNetworkQuestionsEnabledAndLicensed } from '../networkQuestions/selectors';

type IsAnswersClientSupportsQuestionTitleEnabled = (state: YammerState) => boolean;
export const isAnswersClientSupportsQuestionTitleEnabled: IsAnswersClientSupportsQuestionTitleEnabled = (state) =>
  getExperimentTreatment(state, 'AnswerCommunityClientSupportsQuestionTitle') === true;

type IsAnswersCommunityForAllEnabled = (state: YammerState) => boolean;
export const isAnswersCommunityForAllEnabled: IsAnswersCommunityForAllEnabled = (state) => {
  const isAnswersEnabledAndLicensed = isNetworkQuestionsEnabledAndLicensed(state);
  const isAnswersCommunityForAllEnabled = !!getExperimentTreatment(state, 'AnswersCommunityForAll');

  return isAnswersCommunityForAllEnabled && isAnswersEnabledAndLicensed;
};
